/* eslint-disable */
import { produce } from "immer";
import {
  TRANSFER_OUT_FETCH_START,
  TRANSFER_OUT_FETCH_SUCCESS,
  TRANSFER_OUT_FETCH_FAILURE,
} from "../actions/types";

const transferOutReducer = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case TRANSFER_OUT_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case TRANSFER_OUT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case TRANSFER_OUT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default transferOutReducer;
